import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import { getAccessToken } from "../utils/helper/authHelper";

const SOCKET_URL = "http://localhost:5000";

let socketInstance = null;

export function useSocket({ options = {}, isSocketConnectionTry = false }) {

    const socketRef = useRef(null);
    const [connected, setConnected] = useState(false);

    useEffect(() => {
        if (!isSocketConnectionTry) return;

        const userToken = getAccessToken();   

        if (!socketInstance) {
            socketInstance = io(SOCKET_URL, {
                transports: ["websocket", "polling"],
                query: { token: userToken },   
                ...options,
            });

            socketRef.current = socketInstance;

            socketInstance.on("connect", () => {
                setConnected(true);
            });

            socketInstance.on("disconnect", () => {
                setConnected(false);
            });
        }

        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
                socketInstance = null;
            }
        };
    }, [isSocketConnectionTry]);

    const sendMessage = (event, message) => {
        if (socketInstance) {
            socketInstance.emit(event, message);
        } else {
            console.log("Socket instance not available");
        }
    };

    const onMessage = (event, callback) => {
        if (socketInstance) {
            socketInstance.on(event, callback);
        }
    };

    const offMessage = (event) => {
        if (socketInstance) {
            socketInstance.off(event);
        }
    };

    return { connected, sendMessage, onMessage, offMessage };
}
